import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { HeartIcon, MinusIcon } from '@paygreen/paygreen-ui';

const ActionsCell = ({ t, sector, name, updateUserSector, isSelected }) => {
    const [isLoading, setIsLoading] = useState(false);

    const actionIconProps = {
        iconSize: 'sm',
        colorPallet: 'status',
        hasBackground: true,
        hasHover: true,
    };

    const handleChange = async () => {
        setIsLoading(true);
        await updateUserSector(isSelected ? null : sector, name);
        setIsLoading(false);
    };

    return (
        <>
            {!!isSelected && (
                <MinusIcon
                    htmlTag="button"
                    disabled
                    title={t('sectors.table.unlike')}
                    {...actionIconProps}
                    colorPallet="theme"
                    colorTheme="septenary"
                />
            )}
            {!isSelected && (
                <HeartIcon
                    htmlTag="button"
                    disabled={!!isLoading}
                    title={t('sectors.table.like')}
                    onClick={handleChange}
                    {...actionIconProps}
                    colorStatus="success"
                />
            )}
        </>
    );
};

ActionsCell.propTypes = {
    selectedSector: PropTypes.object,
    setModalData: PropTypes.func,
};

export default withTranslation('common')(ActionsCell);
